<script lang="ts">
    import ProfileCard from "./person/ProfileCard.svelte"

    let {
        block,
    }: {
        block: CreditFooterRowBlock
    } = $props()
</script>

<section>
    <div>
        <p>
            {block.content.text}
        </p>
        <ProfileCard
            block={{
                type: "personSmallPreviewCards",
                content: {
                    persons: block.content.persons,
                },
            }}
        />
    </div>
</section>

<style lang="less">
    section {
        width: 100%;
        display: flex;
        padding: 0px var(--default-padding);
        justify-content: center;
        & > div {
            display: flex;
            max-width: var(--extended-max-width);
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap-reverse;
            gap: 1.2rem;
        }
    }
</style>
